"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var __1 = require("..");

var styled_1 = __importDefault(require("@emotion/styled"));

var uuid_1 = require("uuid");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var polished_1 = require("polished");

var content_1 = require("./content");

var react_2 = require("@emotion/react");

var enums_1 = require("../enums");

var ErrorContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n\tmargin-bottom: 8px;\n"])));
var Label = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var size = props.size,
      labelColor = props.labelColor;
  var controlSize = size;
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tcolor: ", ";\n\t\t\tmargin-bottom: ", ";\n\t\t"])), labelColor, enums_1.LabelBottomMargin[controlSize]);
});

var GroupCheckbox = function GroupCheckbox(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? (0, uuid_1.v4)() : _ref$id,
      values = _ref.values,
      options = _ref.options,
      onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      language = _ref.language,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label;

  var _a, _b;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var white = theme.colors.primary.white;
  var _theme$colors$type = theme.colors[type],
      errorColor = _theme$colors$type.error,
      labelColor = _theme$colors$type.label;
  var Container = styled_1.default.fieldset(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tborder: 0;\n\t\tdisplay: inline-block;\n\t"])));

  var _react_1$default$useS = react_1.default.useState(isValid),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      valid = _react_1$default$useS2[0],
      setValid = _react_1$default$useS2[1];

  var onChangeHandler = function onChangeHandler(value, checked) {
    onChange(value, checked);
  };

  var isSelected = function isSelected(value) {
    return values.indexOf(value) > -1;
  };

  react_1.default.useEffect(function () {
    required && setValid(isValid);
  }, [isValid]);
  return (0, jsx_runtime_1.jsxs)(Container, {
    children: [(0, jsx_runtime_1.jsxs)("div", {
      css: {
        padding: !isValid ? 4 : 0,
        borderRadius: !isValid ? 4 : 0,
        backgroundColor: "inherit",
        border: !isValid ? "1px solid ".concat(errorColor) : ""
      },
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        autoResize: false,
        size: "md",
        children: label && (0, jsx_runtime_1.jsxs)(Label, {
          labelColor: labelColor,
          type: type,
          size: size,
          children: [label, required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            color: errorColor,
            children: " *"
          })]
        })
      }), options.map(function (option, index) {
        return (0, jsx_runtime_1.jsx)(__1.Checkbox, {
          className: "checkbox",
          name: option.name,
          checked: isSelected(option.value),
          label: option.display,
          onChange: onChangeHandler,
          value: option.value,
          disabled: option.disabled,
          size: size,
          type: type,
          id: id + index,
          dataTestId: option.dataTestId,
          language: language
        }, option.value);
      })]
    }), required && !valid && (0, jsx_runtime_1.jsx)(ErrorContainer, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        color: type !== "tertiary" ? errorColor : (0, polished_1.mix)(0.2, errorColor, white),
        children: options.length === 1 ? (_a = content_1.content[language]) === null || _a === void 0 ? void 0 : _a.validation.required : (_b = content_1.content[language]) === null || _b === void 0 ? void 0 : _b.validation.atLeastOne
      })
    })]
  });
};

GroupCheckbox.displayName = "GroupCheckbox";
exports.default = GroupCheckbox;